import {MenuPanels} from '../../models/UIModel.js';
import {ShoppeBase} from './shoppe-base.js';
import {Column, Image, Text} from '@wonderlandengine/react-ui/components';
import {Align, Justify} from '@wonderlandengine/react-ui';
import {goToPreviousMenu} from '../utils/goToPreviousMenu.js';
import {UiTexturesManager} from '../components/ui-textures-manager.js';
import {Localization} from '../../utils/Localization.js';

export const ShoppeMalwear = () => {
    return (
        <ShoppeBase
            title={Localization.instance.get('MalwearTitle')}
            onOkay={() => goToPreviousMenu(MenuPanels.Malwear)}
        >
            <Column
                paddingBottom={100}
                justifyContent={Justify.SpaceEvenly}
                alignItems={Align.Center}
                flexGrow={1}
            >
                {' '}
                <Image
                    alignSelf={Align.Center}
                    src={UiTexturesManager.instance.malRainbowFruit}
                    width={350}
                    height={350}
                    margin={35}
                />
                <Text textAlign="center">COMING SOON</Text>
            </Column>
        </ShoppeBase>
    );
};
